import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { ButtonType } from 'src/app/shared/common/components/buttons/button';

export interface ActionItem {
    id: string;
    iconClass: string;
    title: string;
    disabled?: boolean;
    custom?: any; // For custom properties specific to implementations
}

@Component({
    selector: 'panel-header',
    templateUrl: './panel-header.component.html',
    styleUrls: ['./panel-header.component.less'],
    encapsulation: ViewEncapsulation.None
})
export class PanelHeaderComponent {
    @Input() headerTitle: string;
    @Input() showBackButton: boolean = true;
    @Input() backButtonIcon: string = 'icon-arrow-back-black i24';
    @Input() actionItems: ActionItem[] = [];
    @Input() disabled: boolean = false;
    @Input() disableBackAction: boolean = false;

    @Output() backClick = new EventEmitter<void>();
    @Output() actionClick = new EventEmitter<{ item: ActionItem; event: MouseEvent }>();

    ButtonType = ButtonType;

    onBackClick(): void {
        this.backClick.emit();
    }

    onActionClick(item: ActionItem, event: MouseEvent): void {
        if (!this.disabled) {
            this.actionClick.emit({ item, event });
        }
    }
}
